<template>
  <div class="coupon-middle-page">
    <headers :title="title" :goBackHandler="goBack"></headers>
    <List
      ref="list"
      url="/api/app/couponGoods"
      method="get"
      :params="params"
      :on-getdata="onGetdata"
    >
      <div slot="item">
        <course-item v-if="params.type == 1" :course="data_list"></course-item>
        <div class="teacher-list" v-else-if="params.type == 4">
          <div class="oc-item" v-for="item in data_list" :key="item.teacher_id">
            <img :src="item.avatar" alt />
            <div>
              <p>
                <span>{{item.real_name}}</span>
                <font v-if="item.is_collect">已关注</font>
              </p>
              <p>{{item.sex == 1 ? '女':'男'}} {{item.teach_age}}年教龄</p>
            </div>
            <router-link :to="{name: 'OtoPlan', query:{id: item.teacher_id}}">预约</router-link>
          </div>
        </div>
        <div v-else-if="params.type == 2" class="book-list">
          <div
            class="bl-item"
            v-for="(book,index) in data_list"
            :key="index"
            @click="goBook(book.id)"
          >
            <img class="bli-cover" :src="book.cover_img" alt />
            <div>
              <div>
                <p class="bli-title">
                  <span class="quan-icon" v-if="book.is_has_coupon"></span>
                  <font>{{book.name}}</font>
                </p>
                <p class="bli-author">{{book.author}}</p>
              </div>
              <p class="bli-price">
                <icon-price size="mini" :priceType="2"></icon-price>
                <span v-if="book.price">{{book.price | toFixPrice}}</span>
                <span v-else>免费</span>
                <icon-price size="mini" :priceType="2" v-if="book.underlined_price"></icon-price>
                <span class="under-line" v-if="book.underlined_price">{{book.price | toFixPrice}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </List>
  </div>
</template>

<script>
import List from "@/components/List";
import courseItem from "@/components/CourseItem";
import headers from "@/components/Header.vue";
export default {
  name: "CouponMiddle",
  components: {
    List,
    courseItem,
    headers
  },
  data() {
    return {
      title: {
        name: "课程列表"
      },
      params: {
        type: this.$route.query.type,
        coupon_id: this.$route.query.id
      },
      data_list: []
    };
  },
  methods: {
    onGetdata(data) {
      this.data_list = data;
    },
    goBack() {
      if (this.$store.state.app) {
        this.$store.commit("BACK_NORMAL", 0);
      }
      this.$router.go(-1);
    },
    goBook(id) {
      this.$router.push({
        name: "BookDetail",
        query: {
          id
        }
      });
    }
  },
  created() {
    switch (this.$route.query.type) {
      case 1:
        this.title.name = "课程列表";
        break;
      case 4:
        this.title.name = "老师列表";
        break;
      case 2:
        this.title.name = "图书列表";
        break;
      default:
        break;
    }
    if (this.$store.state.app) {
      this.$store.commit("BACK_NORMAL", 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-middle-page {
  @extend %default-bg;
  .teacher-list {
    padding: 0 20px;
  }
  .oc-item {
    display: flex;
    align-items: center;
    padding: 0 30px;
    background: #fff;
    border-radius: 8px;
    height: 162px;
    margin-top: 20px;
    img {
      width: 80px;
      height: 80px;
      margin-right: 24px;
      border-radius: 50%;
      flex: none;
    }
    div {
      flex: 1;
      p {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        &:nth-child(1) {
          padding-bottom: 6px;
          span {
            font-size: 30px;
            color: rgba(89, 89, 89, 1);
            line-height: 42px;
            padding-right: 10px;
          }
          font {
            font-size: 22px;
            color: rgba(234, 122, 47, 1);
          }
        }
        &:nth-child(2) {
          font-size: 24px;
          color: rgba(183, 183, 183, 1);
          line-height: 34px;
        }
      }
    }
    a {
      flex: none;
      width: 140px;
      height: 62px;
      line-height: 62px;
      background: rgba(235, 238, 254, 1);
      border-radius: 31px;
      font-size: 28px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: $theme_color;
      border: none;
      text-align: center;
    }
  }
  .book-list {
    padding: 30px;
    .bl-item {
      height: 226px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.07);
      border-radius: 12px;
      display: flex;
      padding-left: 30px;
      margin-bottom: 30px;
      &:last-child {
        margin: 0;
      }
      .bli-cover {
        width: 118px;
        height: 166px;
        margin-top: 30px;
        margin-right: 30px;
      }
      > div {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .bli-title {
          margin-top: 30px;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(89, 89, 89, 1);
          line-height: 40px;
          max-height: 80px;
          overflow: hidden;
          .quan-icon {
            width: 35px;
            height: 35px;
            background: url("~@/assets/images/quan@3x.png") no-repeat;
            background-size: 100% 100%;
            margin-right: 10px;
            display: inline-block;
            vertical-align: middle;
          }
        }
        .bli-author {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(140, 140, 140, 1);
          line-height: 40px;
        }
        .bli-price {
          span {
            margin-right: 10px;
          }
          /deep/ .price-ico {
            width: 16px;
            margin: 0 4px;
          }
          .under-line {
            font-size: 24px;
            color: #979797;
            text-decoration: line-through;
          }
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(238, 31, 31, 1);
          line-height: 32px;
          padding-bottom: 30px;
        }
      }
    }
  }
}
</style>
